import { render, staticRenderFns } from "./OrticChild.vue?vue&type=template&id=5f6338c8&"
import script from "./OrticChild.vue?vue&type=script&lang=js&"
export * from "./OrticChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports